import { ContactMethodType } from './contact-method.i';
var ContactMethodBuilder = /** @class */ (function () {
    function ContactMethodBuilder() {
        this.contactMethod = {
            type: ContactMethodType.INTERNAL,
            formFields: [],
            externalUrl: '',
            email: ''
        };
    }
    ContactMethodBuilder.prototype.withType = function (type) {
        this.contactMethod.type = type;
        return this;
    };
    ContactMethodBuilder.prototype.withFormFields = function (formFields) {
        this.contactMethod.formFields = formFields;
        return this;
    };
    ContactMethodBuilder.prototype.withExternalUrl = function (url) {
        this.contactMethod.externalUrl = url;
        return this;
    };
    ContactMethodBuilder.prototype.withEmail = function (email) {
        this.contactMethod.email = email;
        return this;
    };
    ContactMethodBuilder.prototype.build = function () {
        return this.contactMethod;
    };
    return ContactMethodBuilder;
}());
export { ContactMethodBuilder };
//# sourceMappingURL=contact-method.builder.js.map